import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import userPreviewReducer from "../Components/Layout/MainContent/LoggedInLanding/reducers/userPreviewReducer";
import downloadAndDelete from "../Components/Layout/MainContent/LoggedInLanding/reducers/downloadAndDeleteLandingReducer";
import modalState from "../Components/common/Modal/reducers/handleModalStateReducer";
import downloadInputInformation from "../Components/Layout/MainContent/DownloadAndDelete/reducers/handleInputChangeReducer";
import loadingAndErrorState from "../Components/Layout/MainContent/DownloadAndDelete/reducers/loadingAndErrorReducer";
import pageContent from "../Components/Layout/MainContent/DownloadAndDelete/reducers/fetchPageContentReducer";
import downloadAmount from "../Components/Layout/MainContent/DownloadAndDelete/reducers/downloadAmountReducer";
import requestHistory from "../Components/Layout/MainContent/DownloadAndDelete/reducers/fetchRequestHistoryReducer";
import currentA11yMessage from "../Components/Layout/MainContent/NavigationHelper/reducers/setA11yContentReducer";
import profileInformation from "../Components/Layout/MainContent/DownloadAndDelete/reducers/fetchProfileAPIReducer";
import selectedDevice from "../Components/Layout/MainContent/DownloadAndDelete/reducers/selectDeviceReducer";
import verifiedSecurePinDevice from "../Components/Layout/MainContent/DownloadAndDelete/reducers/checkIfMDNisSMSCapableReducer";
import deleteLineSelection from "../Components/Layout/MainContent/DownloadAndDelete/reducers/deleteLineSelectionReducer";
import cancelDownloadType from "../Components/Layout/MainContent/DownloadAndDelete/reducers/cancelDownloadReducer";
import marketingPreferences from "../Components/Layout/MainContent/DownloadAndDelete/reducers/marketingPreferencesReducer";
import authAgentFormValues from "../Components/Layout/MainContent/AuthorizedAgent/AssignAgentForm/reducers";
import breadcrumbList from "../Components/common/BreadCrumbs/reducers";
import {
  agentSelectedFlow,
  agentSelectedCustomer,
  agentCustomerHistory,
  agentSelectedCustomerDownload
} from "../Components/Layout/MainContent/AuthorizedAgent/reducers";
import { formerCustomer } from "../Components/Layout/MainContent/FormerCustomer/reducers";
import addressDob from "../Components/Layout/MainContent/FormerCustomer/reducers/addressDobReducer";
import caseCreation from "../Components/Layout/MainContent/FormerCustomer/reducers/caseCreationReducer";
import createUpdateProfile from "../Components/Layout/MainContent/FormerCustomer/reducers/createUpdateProfileReducer";
import pendingCase from "../Components/Layout/MainContent/FormerCustomer/reducers/pendingCaseReducer";
import getUuid from "../Components/Layout/MainContent/FormerCustomer/reducers/getUuidReducer";
import timeFrameData from "../Components/Layout/MainContent/FormerCustomer/reducers/timeFrameReducer";
import fileFormatData from "../Components/Layout/MainContent/FormerCustomer/reducers/fileFormatReducer";
import formerVerifyIdData from "../Components/Layout/MainContent/FormerCustomer/reducers/formerVerifyIdReducer";
import downloadPasswordKey from "../Components/Layout/MainContent/DownloadAndDelete/reducers/passwordKeyReducer";
import userCorrectibleReducer from "../Components/Layout/MainContent/CorrectibleData/reducers/userCorrectibleReducer";
import BreadCrumbsLink from "../Components/Layout/MainContent/FormerCustomer/reducers/requestHistoryBreadcrumbsLink";

const rootReducer = combineReducers({
  userPreviewReducer,
  downloadAndDelete,
  modalState,
  downloadInputInformation,
  downloadAmount,
  requestHistory,
  loadingAndErrorState,
  pageContent,
  currentA11yMessage,
  profileInformation,
  selectedDevice,
  verifiedSecurePinDevice,
  deleteLineSelection,
  cancelDownloadType,
  marketingPreferences,
  authAgentFormValues,
  breadcrumbList,
  agentSelectedCustomer,
  agentSelectedFlow,
  agentCustomerHistory,
  agentSelectedCustomerDownload,
  formerCustomer,
  form: formReducer,
  userCorrectibleReducer,
  addressDob,
  caseCreation,
  createUpdateProfile,
  pendingCase,
  getUuid,
  timeFrameData,
  fileFormatData,
  formerVerifyIdData,
  downloadPasswordKey,
  BreadCrumbsLink
});

export default rootReducer;
